module.exports = __webpack_public_path__ + "img/icon_people.6351199f.png";